<template>
    <v-container fluid class="pa-0">
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <DynamicSnackbar />
                <Hero :show="showHero" />
                <Breadcrumbs :page="page" />
                <MyAccount :page="page" />
                <Footer :show="showFooter" />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import Breadcrumbs from '~/components/Breadcrumbs.vue'
import DynamicSnackbar from '~/components/DynamicSnackbar.vue'
import Footer from '~/components/Footer.vue'
import Hero from '~/components/Hero.vue'
import MyAccount from '~/components/MyAccount.vue'
import isMyAccountRoutes from '~/mixins/isMyAccountRoutes'
import handleSnackbar from '~/mixins/handleSnackbar'
import handleAuth from '~/mixins/handleAuth'
export default {
    name: 'TemplateMyAccount',
    components: {
        Breadcrumbs,
        DynamicSnackbar,
        Footer,
        Hero,
        MyAccount
    },
    mixins: [handleAuth, handleSnackbar, isMyAccountRoutes],
    props: {
        data: {
            type: Object,
            default: null
        },
        page: {
            type: Object,
            default: null
        },
        template: {
            type: String,
            default: 'MyAccount'
        }
    },
    data() {
        return {
            showHero: false,
            showFooter: true,
            showSidebar: true
        }
    }
}
</script>
